"use strict";
module.exports = ['$rootScope', function ($rootScope) {
    var views = [];
    this.register = function (view) {
        if (view.children) {
            view.children.sort(function (v1, v2) {
                return (v1.order || 0) - (v2.order || 0);
            });
        } else {
            view.children = [];
        }
        views.push(view);
        views.sort(function (v1, v2) {
            return (v1.order || 0) - (v2.order || 0);
        });
    };
    this.registerChild = function (parent, view) {

       
        views.forEach(function (item) {
            if (item.state === parent) {
                item.children.push(view);
                item.children.sort(function (v1, v2) {
                    return (v1.order || 0) - (v2.order || 0);
                });
            }
        });
    };
    this.unregister = function (parent, view) {
        var watcher = $rootScope.$watch('$viewContentLoaded', function () {
            views.forEach(function (item, index) {
                if (view) {
                    if (item.state === parent) {
                        item.children.forEach(function (v, i) {
                            if (v.state === view) {
                                item.children.splice(i, 1);
                            }
                        });
                    }
                } else {
                    if (item.state === parent) {
                        views.splice(index, 1);
                    }
                }
            });
            //Unregister Watcher
            watcher();
        });

    };
    this.getViews = function () {
     //   console.log(views);
        return views;
        
    };
}];



//////////////////
// WEBPACK FOOTER
// ./src/gateway/core/services/MainViews.js
// module id = 192
// module chunks = 2